import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  isPrinting = false;
  palletId: string | undefined;

  printDocument(palletId: string) {
    this.isPrinting = true;
    this.palletId = palletId;
    setTimeout(() => {
      window.print();
      this.isPrinting = false;
    }, 1000);
  }
}
